"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTA_TEXTS = exports.ENVS = exports.VIEWS = exports.CHECKOUT_CATEGORIES = exports.FEATURE_TYPES = void 0;
var FEATURE_TYPES;
(function (FEATURE_TYPES) {
    FEATURE_TYPES["Checkout"] = "checkout";
    FEATURE_TYPES["BeneficiaryTokenization"] = "beneficiary_tokenization";
    FEATURE_TYPES["CardTokenization"] = "card_tokenization";
    FEATURE_TYPES["Subscription"] = "subscription";
    FEATURE_TYPES["Issuing"] = "issuing";
    FEATURE_TYPES["Idv"] = "idv";
    FEATURE_TYPES["ReusableLink"] = "reusable_link";
})(FEATURE_TYPES = exports.FEATURE_TYPES || (exports.FEATURE_TYPES = {}));
var CHECKOUT_CATEGORIES;
(function (CHECKOUT_CATEGORIES) {
    CHECKOUT_CATEGORIES["Card"] = "card";
    CHECKOUT_CATEGORIES["Bank"] = "bank";
    CHECKOUT_CATEGORIES["Ewallet"] = "ewallet";
    CHECKOUT_CATEGORIES["Cash"] = "cash";
})(CHECKOUT_CATEGORIES = exports.CHECKOUT_CATEGORIES || (exports.CHECKOUT_CATEGORIES = {}));
var VIEWS;
(function (VIEWS) {
    VIEWS["Desktop"] = "desktop";
    VIEWS["Mobile"] = "mobile";
    VIEWS["Sdk"] = "sdk";
})(VIEWS = exports.VIEWS || (exports.VIEWS = {}));
var ENVS;
(function (ENVS) {
    ENVS["development"] = "development";
    ENVS["qa"] = "qa";
    ENVS["qa_passive"] = "qa_passive";
    ENVS["sandbox"] = "sandbox";
    ENVS["sandbox_passive"] = "sandbox_passive";
    ENVS["intg"] = "intg";
    ENVS["intg_passive"] = "intg_passive";
})(ENVS = exports.ENVS || (exports.ENVS = {}));
var CTA_TEXTS;
(function (CTA_TEXTS) {
    CTA_TEXTS["PLACE_YOUR_ORDER"] = "place_your_order";
    CTA_TEXTS["PAY_NOW"] = "pay_now";
    CTA_TEXTS["MAKE_PAYMENT"] = "make_payment";
    CTA_TEXTS["BUY"] = "buy";
    CTA_TEXTS["DONATE"] = "donate";
    CTA_TEXTS["SAVE"] = "save";
    CTA_TEXTS["ACTIVATE"] = "activate";
    CTA_TEXTS["SUBSCRIBE"] = "subscribe";
    CTA_TEXTS["START_TRIAL"] = "start_trial";
    CTA_TEXTS["START_VERIFICATION"] = "start_verification";
    CTA_TEXTS["PROCEED_TO_PAYMENT"] = "proceed_to_payment";
    CTA_TEXTS["PAY"] = "pay";
    CTA_TEXTS["PURCHASE"] = "purchase";
})(CTA_TEXTS = exports.CTA_TEXTS || (exports.CTA_TEXTS = {}));
